export default __webpack_public_path__ + "b5f2b7897b072a5f241a5447180bf2f5.svg";